// Copyright (c) 2016 Deere & Company

import AllPartRequestsState from '../state';
import {getDefaultState as getSearchFilterDefaultState} from '../state/search-filters';
import searchFilters from '../../../shared/reducers/search-filters';

export default (state = getSearchFilterDefaultState(), action) => {

    const actionTypes = {
        ...searchFilters
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action, AllPartRequestsState) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/reducers/search-filters.js